import { FC, useMemo } from 'react'
import { RenderIf } from '../../../components/RenderIf'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { IProduct } from 'featureSliced/shared/store/reducers/CategoriesReducer/types'
import {
  IIndivPrice,
  IOfferPrice,
} from 'featureSliced/shared/store/reducers/SpecialsReducer/types'
import {
  Description,
  DescriptionContainer,
  PriceContainer,
  SpecialItem,
  SpecialItemImage,
  Title,
  TitleContainer,
} from './styled'
import { useGetTranslatedNames } from 'featureSliced/shared/hooks/useGetTranslatedNames'
import { useGetProductPrice } from 'featureSliced/shared/hooks/useGetProductPrice/indexT'

type PriceType = {
  individualPrice: IIndivPrice | IOfferPrice
  handleProductClick: (product: IProduct) => void
}

export const Price: FC<PriceType> = ({
  individualPrice,
  handleProductClick,
}) => {
  const { getProductName } = useGetTranslatedNames()
  const products = useMySelector((state) =>
    state.categories.items.flatMap((cat) => cat.products)
  )
  const currentProduct = products?.find(
    (product) => product?.id === individualPrice?.productId
  )
  const { getProductPrice } = useGetProductPrice()

  const onProductClick = () => {
    if (currentProduct) {
      handleProductClick(currentProduct)
    }
  }

  const priceString = useMemo(() => {
    if (currentProduct) {
      const productPrice = getProductPrice(
        currentProduct,
        currentProduct.categoryId
      )
      return `${productPrice.finalPriceString} ${productPrice.currency}`
    } else {
      return ''
    }
  }, [currentProduct])

  return (
    <RenderIf condition={!!currentProduct}>
      <SpecialItem onClick={onProductClick}>
        <SpecialItemImage src={currentProduct?.imageUrl} alt="Product" />
        <div>
          <PriceContainer>
            <p>{priceString}</p>
          </PriceContainer>
          <TitleContainer>
            {/* <Title>{currentProduct?.title}</Title> */}
            <Title>{getProductName(currentProduct)}</Title>
          </TitleContainer>
        </div>
        <DescriptionContainer>
          <Description>{individualPrice.description}</Description>
        </DescriptionContainer>
      </SpecialItem>
    </RenderIf>
  )
}
